<template>
  <div>
    <br />
    <form>
      <p class="h4 text-center mb-4">{{ titel }}</p>
      <div class="input-group">
        <div class="input-group-prepend prepend">
          <span class="input-group-text">Pregunta</span>
        </div>
        <input
          aria-label="First name"
          id="name"
          class="form-control"
          v-model="getQuestion"
        />
      </div>

      <br />

      <div class="form-row align-items-center">
        <div class="col-auto">
          <div class="input-group">
            <div class="input-group-prepend prepend">
              <span class="input-group-text">Score</span>
            </div>
            <input
              aria-label="Score"
              id="score"
              class="form-control"
              v-model="qaCopy.score"
            />
          </div>
        </div>
        <div class="col-auto">
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              id="autoSizingCheck"
              v-model="qaCopy.favorite"
            />
            <label class="form-check-label" for="autoSizingCheck"
              >Es favorita</label
            >
          </div>
        </div>
      </div>
      <br />

      <div class="input-group">
        <div class="input-group-prepend prepend">
          <span class="input-group-text">Respuesta</span>
        </div>
        <b-form-textarea
          id="textarea"
          v-model="getAnswer"
          placeholder="Respuesta"
          rows="6"
        ></b-form-textarea>
      </div>

      <br />

      <div class="input-group">
        <div class="input-group-prepend prepend">
          <span class="input-group-text">Categorias</span>
        </div>
        <b-form-select
          v-model="getCategory"
          :options="$store.getters.getTasks"
          text-field="name"
          value-field="category_id"
          @input="setCategory"
        ></b-form-select>
      </div>

      <br />

      <div class="input-group">
        <div class="input-group-prepend prepend">
          <span class="input-group-text">Sub Categorias</span>
        </div>
        <b-form-select
          v-model="getSubcategory"
          :options="selected"
          text-field="name"
          value-field="subcategory_id"
          class="form-control"
          @input="setSubCategory"
        ></b-form-select>
      </div>

      <br />

      <div
        class="btn-group"
        role="group"
        aria-label="Basic example"
        v-show="this.update"
      >
        <button type="button" class="btn btn-warning" @click="editar(qaCopy)">
          Guardar
        </button>
        <button type="button" class="btn btn-danger" @click="eliminar(qaCopy)">
          Borrar
        </button>
        <button type="button" class="btn btn-success" @click="nuevo">
          Nuevo
        </button>
      </div>

      <div class v-show="!this.update">
        <button
          type="button"
          class="btn btn-success btn-lg btn-block"
          @click="agregar"
        >
          Agregar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { createNewQA, editQA, deleteQA } from "./../../api/conection";

export default {
  name: "qaForm",
  components: {
    Multiselect,
  },
  props: {
    tags: {
      type: Array,
      default: [],
    },
    qa: {
      type: Object,
      default: {},
    },
    update: false,
  },
  data() {
    return {
      titel: "Formulario de Carga de preguntas",
      subcategories: [],
      qaCopy: {},
    };
  },

  computed: {
    selected() {
      return this.subcategories;
    },
    getCategory() {
      return this.qaCopy.categories.length
        ? this.qaCopy.categories[0].category_id
        : "";
    },
    getSubcategory() {
      console.log("subcategories", this.qaCopy.subcategories);
      return this.qaCopy.subcategories.length
        ? this.qaCopy.subcategories[0].subcategory_id
        : "";
    },
    getAnswer: {
      // getter
      get: function() {
        return this.qaCopy.answers.length ? this.qaCopy.answers[0].body : "";
      },
      // setter

      set: function(setValues) {
        this.qaCopy.answers[0].body = setValues;
      },
    },
    getQuestion: {
      // getter
      get: function() {
        return this.qaCopy.body;
      },
      // setter

      set: function(setValues) {
        this.qaCopy.body = setValues;
      },
    },
  },
  watch: {
    qa: {
      handler(newQa) {
        // Clonar el objeto qa a qaCopy
        this.qaCopy = Object.assign({}, newQa);
        console.log("watch");
      },
      deep: false, // Observar cambios en las propiedades anidadas de this.qa
      immediate: true, // Ejecutar el watcher inmediatamente al inicio
    },
  },
  methods: {
    setCategory(category_id) {
      const filter = this.tags.find((tag) => tag.category_id === category_id);
      const { is_menu, name } = filter;
      this.qaCopy.categories[0] = { category_id, is_menu, name };
      const subcategories = filter ? filter.subcategories : null;
      this.subcategories = subcategories;
    },
    setSubCategory(subcategory_id) {
      const filter = this.subcategories.find(
        (sub) => sub.subcategory_id === subcategory_id
      );

      const { name } = filter;
      const { category_id } = this.qaCopy.categories[0];
      this.qaCopy.subcategories[0] = { category_id, subcategory_id, name };
    },
    agregar() {
      const categories = [
        this.tags.find(
          (tag) => tag.category_id === this.qaCopy.categories[0].category_id
        ),
      ];
      const subcategories = [
        categories[0].subcategories.find(
          (subcat) =>
            subcat.subcategory_id ===
            this.qaCopy.subcategories[0].subcategory_id
        ),
      ];

      const body = this.qaCopy;
      createNewQA(this.qaCopy)
        .then((response) => {
          if (response.status === 201) {
            body.question_id = response.body.question_id;
            /* limpio formulario */
            this.nuevo();
            this.$store.dispatch("addQAAction", response.body);
          }
        })
        .catch((err) => {
          /* limpio formulario */
          this.nuevo();
          console.log(err);
        });
    },
    editar(ctg) {
      const id = ctg.question_id;
      const categories = [
        this.tags.find(
          (tag) => tag.category_id === ctg.categories[0].category_id
        ),
      ];
      const subcategories = [
        categories[0].subcategories.find(
          (subcat) =>
            subcat.subcategory_id === ctg.subcategories[0].subcategory_id
        ),
      ];
      ctg.categories = categories;
      ctg.subcategories = subcategories;
      editQA(ctg, id)
        .then((response) => {
          if (response.status === 200) {
            this.$store.dispatch("updateQAAction", ctg);
            /* limpio formulario */
            this.nuevo();
          } else {
            alert(
              "Revisa el score o los valores ingresados que no estén repetidos"
            );
          }
          //console.log(editQuest);
        })
        .catch((err) => {
          console.log(err);
          /* limpio formulario */
          this.nuevo();
        });
    },
    eliminar(quest) {
      const body = { answer_id: quest.answers[0].answer_id };
      if (confirm("Está seguro que quiere borrar ésta pregunta ?")) {
        deleteQA(quest.question_id, body)
          .then((result) => {
            //debugger;
            if (result.status === 200) {
              /* limpio formulario */
              this.nuevo();
              this.$store.dispatch("deleteQAAction", quest.question_id);
            }
          })
          .catch((err) => {
            /* limpio formulario */
            this.nuevo();
            console.log(err);
          });
      }
    },
    nuevo() {
      this.$store.dispatch("unSelectQAAction", {});
    },
  },
};
</script>

<style>
#score {
  width: 80px;
}

.input-group {
  width: 100%;
}
.prepend {
  width: 130px;
}
.input-group-text {
  min-width: 150px;
}
form {
  padding: 15px;
  max-width: 500px;
}
</style>
